module.exports = __webpack_public_path__ + "img/insurance-parcel.3d12f493.png";